<template>
    <div class="case-page">

        <!-- 客户案例标题 -->
        <div class="page-header">
            <div class="client-category">电商行业 · 母婴用品</div>
            <h1 class="main-title">某知名母婴品牌裂变增长案例</h1>
            <div class="client-name">某知名母婴连锁品牌</div>
        </div>

        <!-- 关键数据指标 -->
        <div class="stats-container">
            <div class="stats-grid">
                <div class="stat-card">
                    <div class="stat-number">300%</div>
                    <div class="stat-desc">用户增长</div>
                </div>
                <div class="stat-card">
                    <div class="stat-number">180%</div>
                    <div class="stat-desc">销售提升</div>
                </div>
                <div class="stat-card">
                    <div class="stat-number">68%</div>
                    <div class="stat-desc">复购率提升</div>
                </div>
                <div class="stat-card">
                    <div class="stat-number">3个月</div>
                    <div class="stat-desc">项目周期</div>
                </div>
            </div>
        </div>

        <!-- 横幅图片 -->
        <div class="banner-section">
            <div class="banner-image">
                <img src="../assets/banner.jpg" alt="背景图" class="banner-img">
            </div>
        </div>

        <!-- 项目背景与挑战 -->
        <div class="section-container">
            <div class="section-header">
                <div class="section-number">01</div>
                <h2 class="section-title">项目背景与挑战</h2>
            </div>
            <div class="content-box">
                <div class="content-text">客户是国内知名母婴连锁品牌，拥有线下门店50+，线上电商平台年销售额超2亿。主要产品涵盖母婴用品、童装、玩具等多个品类，目标用户为25-35岁的年轻父母。</div>
                <div class="content-text">随着市场竞争加剧，客户面临以下核心挑战:</div>
                
                <div class="challenges-grid">
                    <div class="challenge-card">
                        <div class="flex-box">
                            <div class="challenge-icon">⚠️</div>
                            <h3 class="challenge-title">获客成本高企</h3>
                        </div>
                        <div class="challenge-desc">传统电商平台推广成本持续上升，CAC(客户获取成本)达到200元/人，远超行业平均水平</div>
                    </div>
                    <div class="challenge-card">
                        <div class="flex-box">
                            <div class="challenge-icon">⚠️</div>
                            <h3 class="challenge-title">用户活跃度低</h3>
                        </div>
                        <div class="challenge-desc">会员复购率仅25%，用户生命周期短，缺乏有效的用户激活与留存机制</div>
                    </div>
                    <div class="challenge-card">
                        <div class="flex-box">
                            <div class="challenge-icon">⚠️</div>
                            <h3 class="challenge-title">线上线下数据割裂</h3>
                        </div>
                        <div class="challenge-desc">线下门店与线上平台数据相互不通，无法实现全渠道用户运营与精准营销</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 解决方案与实施 -->
        <div class="section-container">
            <div class="section-header">
                <div class="section-number">02</div>
                <h2 class="section-title">解决方案与实施</h2>
            </div>
            
            <div class="solution-intro">
                <div class="content-text">泰梦科技为客户定制开发了一套完整的裂变营销平台，整合线上线下渠道，构建“社交裂变+会员运营+数据驱动”的增长体系，具体实施内容包括：</div>
            </div>

            <div class="solutions">
                <!-- 社交裂变系统开发 -->
                <div class="solution-card">
                    <div class="solution-header">
                        <div class="solution-icon">
                            <div class="icon-circle">
                                <i class="icon"><svg t="1767077323423" class="icon" viewBox="0 0 1072 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1974" width="200" height="200"><path d="M894.518 664.888c-68.635 0-124.721 36.712-150.81 93.733l-331.73-141.067a195.394 195.394 0 0 0 29.998-106.338c0-16.402-1.927-32.86-5.835-48.326l211.796-164.295c28.072 21.245 63.847 33.849 103.476 33.849 95.772 0 167.324-71.553 167.324-166.222C918.737 71.498 847.184 0 751.414 0S585.08 71.498 585.08 166.222c0 24.163 4.844 46.399 12.605 65.718L402.292 381.705c-38.638-57.957-102.485-98.522-175.029-98.522A214.107 214.107 0 0 0 12.603 496.74v0.935a214.107 214.107 0 0 0 214.66 214.548c44.528 0 86.084-11.559 119.988-32.805l380.99 162.37c4.844 89.826 74.471 156.535 166.277 156.535 95.772 0 166.334-71.553 166.334-166.222 0-94.724-71.553-167.212-166.278-167.212z" fill="#2563EB" p-id="1975"></path></svg></i>
                            </div>
                        </div>
                        <div>
                            <div class="solution-title">社交裂变系统开发</div>
                            <div class="solution-text">开发基于微信生态的社交裂变系统，包含以下核心功能:</div>
                        </div>
                    </div>
                    <ul class="feature-list">
                        <li>拼团活动：2人/3人/5人多团模式，支持阶梯价格设置</li>
                        <li>分销体系：二级分销机制，自定义佣金比例，实时结算</li>
                        <li>助力活动：砍价、助力等轻量化裂变工具</li>
                        <li>裂变海报：AI智能生成个性化裂变海报，一键分享</li>
                    </ul>
                </div>

                <!-- 会员积分体系重构 -->
                <div class="solution-card">
                    <div class="solution-header">
                        <div class="solution-icon">
                            <div class="icon-circle">
                                <i class="icon"><svg t="1767077377186" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3984" width="200" height="200"><path d="M912.955077 882.786462a37.139692 37.139692 0 0 1-74.279385 0v-0.433231h-1.063384a294.754462 294.754462 0 0 0-285.538462-255.035077c-3.190154 0.118154-6.301538 0.472615-9.531077 0.472615s-6.321231-0.354462-9.491692-0.472615a294.754462 294.754462 0 0 0-285.341539 255.035077h-0.905846v0.433231a37.139692 37.139692 0 0 1-74.279384 0l-0.33477-3.387077a35.446154 35.446154 0 0 1 2.678154-13.410462A365.449846 365.449846 0 0 1 395.815385 583.384615a253.164308 253.164308 0 0 1-113.644308-210.530461A257.732923 257.732923 0 0 1 542.641231 117.937231a257.732923 257.732923 0 0 1 260.430769 254.916923 253.164308 253.164308 0 0 1-113.565538 210.471384 365.312 365.312 0 0 1 221.518769 286.129231 35.268923 35.268923 0 0 1 1.595077 9.944616zM728.615385 372.932923a186.072615 186.072615 0 0 0-372.04677 0 186.072615 186.072615 0 0 0 372.04677 0z" fill="#2563EB" p-id="3985"></path></svg></i>
                            </div>
                        </div>
                        <div>
                            <div class="solution-title">会员积分体系重构</div>
                            <div class="solution-text">设计并开发全新的会员积分体系，提升用户粘性:</div>
                        </div>
                    </div>
                    <ul class="feature-list">
                        <li>成长体系：L1-L5会员等级，对应不同权益与特权</li>
                        <li>积分任务：每日签到、邀请好友、购物消费等积分获取途径</li>
                        <li>积分消耗：兑换商品、抵扣现金、参与抽奖等多样化消耗场景</li>
                        <li>储值功能：会员储值享额外赠送，提升用户忠诚度</li>
                    </ul>
                </div>

                <!-- 全渠道数据中台 -->
                <div class="solution-card">
                    <div class="solution-header">
                        <div class="solution-icon">
                            <div class="icon-circle">
                                <i class="icon"><svg t="1767077431518" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5222" width="200" height="200"><path d="M138.545152 765.825024l95.52896 0c16.662528 0 30.16704-13.50656 30.16704-30.164992L264.241152 309.9648c0-16.662528-13.50656-30.16704-30.16704-30.16704L138.545152 279.79776c-16.662528 0-30.16704 13.50656-30.16704 30.16704l0 425.693184C108.376064 752.318464 121.882624 765.825024 138.545152 765.825024z" fill="#2563EB" p-id="5223"></path><path d="M445.435904 765.825024l95.52896 0c16.662528 0 30.16704-19.744768 30.16704-44.10368L571.131904 99.325952c0-24.36096-13.50656-44.107776-30.16704-44.107776l-95.52896 0c-16.66048 0-30.16704 19.746816-30.16704 44.107776l0 622.395392C415.268864 746.080256 428.773376 765.825024 445.435904 765.825024z" fill="#2563EB" p-id="5224"></path><path d="M752.326656 765.825024l95.52896 0c16.662528 0 30.16704-18.345984 30.16704-40.986624l0-578.3552c0-22.636544-13.50656-40.984576-30.16704-40.984576l-95.52896 0c-16.662528 0-30.16704 18.348032-30.16704 40.984576l0 578.3552C722.157568 747.476992 735.664128 765.825024 752.326656 765.825024z" fill="#2563EB" p-id="5225"></path><path d="M6.144 816.103424l968.704 0 0 50.2784-968.704 0 0-50.2784Z" fill="#2563EB" p-id="5226"></path></svg></i>
                            </div>
                        </div>
                        <div>

                            <div class="solution-title">全渠道数据中台</div>
                            <div class="solution-text">打通线上线下数据，构建统一用户视图:</div>
                        </div>
                    </div>
                    <ul class="feature-list">
                        <li>数据整合：线上电商、小程序、线下门店数据统一采集与管理</li>
                        <li>用户画像：360°用户标签体系，精准用户分层</li>
                        <li>营销自动化：基于用户行为触发个性化营销活动</li>
                        <li>BI报表：实时监控关键指标，数据驱动决策</li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 项目实施流程 -->
        <div class="section-container">
            
            <div class="process-timeline">
                <div class="step-title">项目实施流程</div>
                <div class="process-step">
                    <div class="step-number">1</div>
                    <div class="step-content">
                        <h3 class="step-title">需求分析与方案设计</h3>
                        <div class="step-desc">第1-2周<br>深入调研客户业务场景，明确需求痛点，输出详细解决方案与技术架构设计</div>
                    </div>
                </div>
                <div class="process-step">
                    <div class="step-number">2</div>
                    <div class="step-content">
                        <h3 class="step-title">系统开发与测试</h3>
                        <div class="step-desc">第3-10周<br>分模块并行开发，每周迭代交付，严格测试确保系统稳定性与安全性</div>
                    </div>
                </div>
                <div class="process-step">
                    <div class="step-number">3</div>
                    <div class="step-content">
                        <h3 class="step-title">数据迁移与系统部署</h3>
                        <div class="step-desc">第11周<br>完成历史数据迁移，系统部署上线，进行生产环境测试与优化</div>
                    </div>
                </div>
                <div class="process-step">
                    <div class="step-number">4</div>
                    <div class="step-content">
                        <h3 class="step-title">运营支持与效果优化</h3>
                        <div class="step-desc">第12周起<br>提供专业运营支持，根据数据反馈持续优化系统功能与营销策略</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 项目成果与数据 -->
        <div class="section-container">
            <div class="section-header">
                <div class="section-number">03</div>
                <h2 class="section-title">项目成果与数据</h2>
            </div>
            
            <div class="results-content">
                <div class="content-text">系统上线3个月后，客户业务指标获得显著提升，具体成果如下：</div>
                
                <div class="charts-container">
                    <div class="chart-item">
                        <div class="chart-title">用户增长趋势</div>
                        <img src="../assets/chart-line.png" alt="用户增长趋势图" class="chart-img">
                    </div>
                    <div class="chart-item">
                        <div class="chart-title">销售额增长对比</div>
                        <img src="../assets/chart.png" alt="销售额增长对比图" class="chart-img">
                    </div>
                </div>

                <div class="results">
                    <div class="result-item">
                        <div class="flex-box">
                            <div class="result-icon">💰</div>
                            <div class="result-title">获客成本显著降低</div>
                        </div>
                        <div class="result-desc">通过社交裂变模式，客户获取成本从200元/人降至60元/人，降低70%，累计节省营销费用超300万元</div>
                    </div>
                    <div class="result-item">
                        <div class="flex-box">
                            <div class="result-icon">🔄</div>
                            <div class="result-title">会员复购率大幅提升</div>
                        </div>
                        <div class="result-desc">会员复购率从25%提升至68%，用户生命周期价值(LTV)提升2.3倍，客单价从320元提升至480元</div>
                    </div>
                    <div class="result-item">
                        <div class="flex-box">
                            <div class="result-icon">👥</div>
                            <div class="result-title">私域流量池构建</div>
                        </div>
                        <div class="result-desc">3个月内构建20万+精准用户的私域流量池，日均活跃用户3万+，用户留存率提升至75%</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 客户评价 -->
        <div class="section-container">
            <div class="section-header">
                <div class="section-number">04</div>
                <h2 class="section-title">客户评价</h2>
            </div>
            
            <div class="testimonial-box">
                <div class="star-rating">⭐⭐⭐⭐⭐</div>
                <div class="testimonial-text">“泰梦科技为我们开发的裂变营销系统彻底改变了我们的获客方式。上线三个月，我们的用户量增长了300%，销售额提升180%，这是我们之前不敢想象的成绩。他们不仅提供了优质的技术解决方案，还为我们提供了专业的运营指导，真正做到了技术与业务的深度结合。”</div>
                <div class="client-info">
                    <div class="client-avatar">👤</div>
                    <div class="client-detail">
                        <div class="client-name">张女士</div>
                        <div class="client-position">市场总监 @ 某知名母婴连锁品牌</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 相关成功案例 -->
        <div class="section-container">
            <div class="section-header">
                <div class="section-number">05</div>
                <h2 class="section-title">相关成功案例</h2>
            </div>
            
            <div class="related-cases">
                <div class="case-card">
                    <img src="../assets/case1.jpg" alt="教育行业案例" class="case-img">
                    <div class="case-info">
                        <div class="case-tag">教育行业</div>
                        <h3 class="case-title">在线教育平台分销裂变系统</h3>
                        <div class="case-stats">
                            <div class="stat-item">
                                <div class="stat-value">500+</div>
                                <div class="stat-label">分销用户</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-value">250万</div>
                                <div class="stat-label">销售额</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="case-card">
                    <img src="../assets/case2.jpg" alt="零售行业案例" class="case-img">
                    <div class="case-info">
                        <div class="case-tag">零售行业</div>
                        <h3 class="case-title">连锁零售品牌会员裂变系统</h3>
                        <div class="case-stats">
                            <div class="stat-item">
                                <div class="stat-value">220%</div>
                                <div class="stat-label">会员增长</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-value">150%</div>
                                <div class="stat-label">复购提升</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 行动号召 -->
        <div class="cta-section">
            <div>
                <h2 class="cta-title">想了解更多裂变营销方案?</h2>
                <p class="cta-subtitle">填写表单领取免费咨询，我们的专家团队将为您提供定制化方案</p>
            </div>
            <button class="cta-button">立即咨询</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    }
}
</script>

<style type="text/css" lang="scss" scoped>
.case-page {
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
    background-color: #fff;
    color: #333;
    padding: 20px 0;
    .page-header {
        max-width: 1200px;
        margin: 0 auto 20px;
        padding: 0 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .client-category {
            font-size: 12px;
            font-weight: 700;
            color: #2563EB;
            margin-bottom: 8px;
            padding: 6px 10px;
            border-radius: 60px;
            background: #DBEAFE;
        }
        
        .main-title {
            font-size: 28px;
            font-weight: 700;
            color: #1a1a1a;
            margin: 0 0 10px 0;
        }
        
        .client-name {
            font-size: 16px;
            color: #666;
        }
    }
    
    .stats-container {
        max-width: 1200px;
        margin: 0 auto 40px;
        padding: 0 40px;
        .stats-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;
            
            .stat-card {
                background: #f8fafc;
                border-radius: 8px;
                padding: 20px 10px;
                text-align: center;
                
                .stat-number {
                    font-size: 24px;
                    font-weight: 700;
                    color: #1D4ED8;
                    margin-bottom: 5px;
                    line-height: 1;
                }
                
                .stat-desc {
                    font-size: 14px;
                    color: #666;
                }
            }
        }
    }
    
    .banner-section {
        max-width: 1200px;
        margin: 0 auto 40px;
        padding: 0 40px;
        
        .banner-image {
            border-radius: 8px;
            overflow: hidden;
            
            .banner-img {
                width: 100%;
                height: 200px;
                object-fit: cover;
            }
        }
    }
    
    .section-container {
        max-width: 1200px;
        margin: 0 auto 40px;
        padding: 0 40px;
        text-align: start;
        .section-header {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            
            .section-number {
                font-size: 20px;
                font-weight: 700;
                color: #1D4ED8;
                margin-right: 10px;
                background-color: #DBEAFE;
                border-radius: 100%;
                padding: 8px 10px ;
            }
            
            .section-title {
                font-size: 20px;
                font-weight: 700;
                color: #1a1a1a;
                margin: 0;
            }
        }
        
        .content-box {
            background: #fff;
            padding: 0;
            
            .content-text {
                font-size: 20px;
                line-height: 1.8;
                color: #444;
                margin-bottom: 20px;
            }
            
            .challenges-grid {
                
                .challenge-card {
                    background: #f8fafc;
                    border-radius: 8px;
                    padding: 20px;
                    margin-bottom: 20px;
                    .challenge-icon {
                        font-size: 16px;
                        color: #F59E0B;
                        margin: 0 10px 10px 0;
                    }
                    
                    .challenge-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #1a1a1a;
                        margin-bottom: 10px;
                    }
                    
                    .challenge-desc {
                        font-size: 14px;
                        color: #666;
                        line-height: 1.6;
                    }
                }
            }
        }
        
        .solution-intro {
            margin-bottom: 20px;
            
            .content-text {
                font-size: 20px;
                line-height: 1.8;
                color: #444;
            }
        }
        
        .solutions {
            .solution-card {
                padding: 20px;
                margin-bottom: 10px;
                .solution-header {
                    display: flex;
                    align-items: center;
                    margin-bottom: 15px;
                    color: #475569;
                    .solution-icon {
                        font-size: 20px;
                        color: #1D4ED8;
                        margin-right: 10px;
                        .icon-circle {
                            width: 60px;
                            height: 60px;
                            border-radius: 12px;
                            background: #DBEAFE;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 0 auto;
                            .icon {
                                font-size: 20px;
                                width: 20px;
                            }
                        }
                    }
                    
                    .solution-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #475569;
                        margin-bottom: 10px;
                    }
                }
                
                .feature-list {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                    
                    li {
                        padding-left: 20px;
                        position: relative;
                        margin-bottom: 10px;
                        font-size: 14px;
                        line-height: 1.6;
                        color: #444;
                    }
                }
            }
        }
        
        .process-timeline {
            border-radius: 16px;
            border: 1px solid #e2e8f0;
            padding: 20px;
            .step-title {
                font-size: 16px;
                font-weight: 600;
                color: #1a1a1a;
                margin-bottom: 15px;
            }
            .process-step {
                display: flex;
                margin-bottom: 20px;
                
                &:last-child {
                    margin-bottom: 0;
                }
                
                .step-number {
                    width: 50px;
                    height: 50px;
                    background: #1D4ED8;
                    color: #fff;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    font-weight: 700;
                    margin-right: 15px;
                    flex-shrink: 0;
                }
                
                .step-content {
                    flex: 1;
                    
                    .step-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #1a1a1a;
                        margin-bottom: 5px;
                    }
                    
                    .step-desc {
                        font-size: 14px;
                        color: #666;
                        line-height: 1.6;
                    }
                }
            }
        }
        
        .results-content {
            .content-text {
                font-size: 20px;
                color: #444;
                margin-bottom: 20px;
                text-align: start;
            }
            
            .charts-container {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 40px;
                margin-bottom: 20px;
                
                .chart-item {
                    border: 1px solid #e2e8f0;
                    padding: 20px;
                    border-radius: 16px;
                    .chart-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #1a1a1a;
                        margin-bottom: 10px;
                    }
                    
                    .chart-img {
                        width: 100%;
                        border-radius: 8px;
                    }
                }
            }
            
            .results {
                .result-item {
                    background: #EFF6FF;
                    border-radius: 8px;
                    padding: 20px;
                    margin-bottom: 20px;
                    .result-icon {
                        font-size: 20px;
                        margin-bottom: 10px;
                    }
                    
                    .result-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #1a1a1a;
                        margin: 0 0 10px 10px;
                    }
                    
                    .result-desc {
                        font-size: 14px;
                        color: #666;
                        line-height: 1.5;
                    }
                }
            }
        }
        
        .testimonial-box {
            border-radius: 8px;
            padding: 20px;
            border: 1px solid #e2e8f0;
            
            .star-rating {
                font-size: 16px;
                color: #F59E0B;
                margin-bottom: 10px;
            }
            
            .testimonial-text {
                font-size: 14px;
                line-height: 1.8;
                color: #444;
                margin-bottom: 20px;
            }
            
            .client-info {
                display: flex;
                align-items: center;
                
                .client-avatar {
                    width: 30px;
                    height: 30px;
                    background: #e2e8f0;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                }
                
                .client-detail {
                    .client-name {
                        font-size: 14px;
                        font-weight: 600;
                        color: #1a1a1a;
                    }
                    
                    .client-position {
                        font-size: 12px;
                        color: #666;
                    }
                }
            }
        }
        
        .related-cases {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
            
            .case-card {
                overflow: hidden;
                border-radius: 8px;
                padding-bottom: 20px;
                border: 1px solid #e2e8f0;
                .case-img {
                    width: 100%;
                    height: 250px;
                    object-fit: cover;
                }
                .case-info {
                    padding: 20px;
                }
                .case-tag {
                    color: #2563EB;
                    font-size: 12px;
                    padding-bottom: 10px;
                }
                
                .case-title {
                    font-size: 16px;
                    font-weight: 600;
                    color: #1a1a1a;
                }
                
                .case-stats {
                    display: flex;
                    padding: 0 10px 10px 10px;
                    gap: 80px;
                    
                    .stat-item {
                        .stat-value {
                            font-size: 16px;
                            font-weight: 700;
                            color: #000;
                        }
                        
                        .stat-label {
                            font-size: 12px;
                            color: #666;
                        }
                    }
                }
            }
        }
    }
    
    .cta-section {
        margin: 0 auto 40px;
        padding: 30px 40px;
        background: #1D4ED8;
        border-radius: 8px;
        text-align: center;
        color: white;
        display: flex;
        justify-content: space-between;
        text-align: start;
        width: 1280px;
        .cta-title {
            font-size: 20px;
            font-weight: 700;
            margin-bottom: 10px;
        }
        
        .cta-subtitle {
            font-size: 14px;
            margin-bottom: 20px;
            opacity: 0.9;
        }
        
        .cta-button {
            background: white;
            color: #1D4ED8;
            border: none;
            padding: 5px 12px;
            font-size: 14px;
            font-weight: 600;
            border-radius: 4px;
            cursor: pointer;
        }
    }

    /* 响应式设计 */
    @media (max-width: 768px) {
        .stats-grid,
        .challenges-grid,
        .solutions,
        .results,
        .related-cases,
        .charts-container {
            grid-template-columns: 1fr !important;
        }
        
        .section-container,
        .page-header,
        .stats-container,
        .banner-section {
            padding: 0 20px;
        }
    }
}
.flex-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
</style>